/**
 * Get coupon code from Redux state.
 *
 * @param {Object} state - Redux state
 * @returns {string|null} Coupon code or null
 */
export const selectCouponCode = (state) => state.search?.get('couponCode') || null;

/**
 * Get discounted trips by coupon code from Redux state.
 *
 * Retrieves the array of discounted trips for a specific coupon code.
 * Returns empty array if not found.
 *
 * @param {string} couponCode - The coupon code to retrieve discounts for
 * @returns {Function} Selector function that takes state and returns discounted trips array
 */
export const selectDiscountedTripsByCoupon = (couponCode) => (state) =>
  state.search?.getIn(['discountedTripsByCoupon', couponCode], []);
